import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

export const companyAnalytics = new AnalyticsService("Company Record Pane");
export const personAnalytics = new AnalyticsService("Person Record Pane");
export const dealAnalytics = new AnalyticsService("Deal Record Pane");
